module.exports = __webpack_public_path__ + "img/event-vendor.486daa04.jpg";